import styled from 'styled-components';
import { Box } from 'reflexbox';
import { colors } from '../../../../healtheraComponents';

export const StyledRow = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const StyledText = styled.span<{ isGreen?: boolean; isRed?: boolean }>`
  font-size: 18px;
  font-weight: 700;

  color: ${(props) => {
    if (props.isGreen) {
      return colors.HEALTHERA_GREEN;
    }
    if (props.isRed) {
      return colors.HEALTHERA_RED;
    }

    return colors.DARK;
  }};
`;

export const StyledImagesContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
});

export const ColumnWithGap = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
})

export const StyledAddMoreButtonContainer = styled(Box)({
  marginTop: '12px',
  display: 'flex',
  justifyContent: 'center',
});
